import * as React from 'react';
import { cn } from '../cn';
import { Skeleton } from './skeleton';

export interface CardSkeletonProps {
  /** Număr de carduri afișate (în grid). Default 4. */
  count?: number;
  /** Variantă: 'kpi' (titlu + valoare mare), 'list-item' (avatar + 2 linii), 'media' (cu thumbnail) */
  variant?: 'kpi' | 'list-item' | 'media';
  className?: string;
}

/**
 * Schelet pentru carduri de tip KPI (dashboard), list-item (cards verticale)
 * sau media (cu thumbnail/imagine). Render în grid responsive.
 */
export function CardSkeleton({ count = 4, variant = 'kpi', className }: CardSkeletonProps) {
  return (
    <div
      role="status"
      aria-label="Se încarcă..."
      className={cn(
        'grid gap-3',
        variant === 'kpi' && 'grid-cols-2 md:grid-cols-4',
        variant === 'list-item' && 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
        variant === 'media' && 'grid-cols-1 md:grid-cols-3',
        className,
      )}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="rounded-xl border border-neutral-200 dark:border-neutral-800 p-4 bg-white dark:bg-neutral-900"
        >
          {variant === 'kpi' && (
            <div className="space-y-2">
              <Skeleton width="50%" height={11} rounded="sm" delay={i * 50} />
              <Skeleton width="70%" height={28} rounded="md" delay={i * 50 + 30} />
              <Skeleton width="40%" height={9} rounded="sm" delay={i * 50 + 60} />
            </div>
          )}
          {variant === 'list-item' && (
            <div className="flex items-start gap-3">
              <Skeleton width={40} height={40} rounded="full" delay={i * 60} />
              <div className="flex-1 space-y-2">
                <Skeleton width="60%" height={12} rounded="sm" delay={i * 60 + 20} />
                <Skeleton width="90%" height={10} rounded="sm" delay={i * 60 + 40} />
              </div>
            </div>
          )}
          {variant === 'media' && (
            <div className="space-y-3">
              <Skeleton width="100%" height={140} rounded="lg" delay={i * 70} />
              <Skeleton width="80%" height={12} rounded="sm" delay={i * 70 + 30} />
              <Skeleton width="50%" height={10} rounded="sm" delay={i * 70 + 60} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
